import React from 'react';

export default function MealSlotMealTypeFilterBar({
  mealTypes = [],
  selectedMealType,
  onSelectMealType,
  buttonClassName = 'px-3 py-1 rounded-md font-medium text-sm',
  activeClassName = 'bg-orange-primary text-white',
  inactiveClassName = 'bg-gray-100 text-gray-700 hover:bg-gray-200',
}) {
  return (
    <div className="flex gap-2 flex-wrap">
      {mealTypes.map((period) => (
        <button
          key={period}
          type="button"
          onClick={() => onSelectMealType(period)}
          className={`${buttonClassName} transition-colors focus:outline-none focus:ring-0 ${
            selectedMealType === period ? activeClassName : inactiveClassName
          }`}
        >
          {period}
        </button>
      ))}
    </div>
  );
}
